import { useLocale } from 'next-intl';

import { useGeoContext } from '../contexts/GeoProvider';

//Returns TRUE if customer is shopping in selected country.
const useMatchUserCountry = (userCountry: string): boolean => {
  const { countryData } = useGeoContext();
  const countryCode = countryData?.countryCode;
  const locale = useLocale();
  const routerLocale = locale === 'ja' ? 'jp' : locale;
  return (
    countryCode?.toLowerCase() === userCountry.toLowerCase() ||
    routerLocale === userCountry.toLowerCase()
  );
};

export default useMatchUserCountry;
